import { Injectable } from '@angular/core';
import { McticHttpClient } from '@mctic/ng-core';
import { Identity } from '..';
import { Observable, BehaviorSubject } from 'rxjs';
import { FaturamentoVO } from "../shared/model/faturamento-vo.model";

@Injectable({
  providedIn: 'root'
})
export class FaturamentoProdutoService {

  private readonly service = '/sepin-backend/rest/faturamento-produtos';
  private faturamentoContrapartida$: BehaviorSubject<number> = new BehaviorSubject<number>(null);

  constructor(private readonly http: McticHttpClient) {
  }

  obterFaturamentoProduto(idFaturamentoProduto: number): Observable<FaturamentoVO> {
    return this.http.get<FaturamentoVO>(`${this.service}/${idFaturamentoProduto}`);
  }

  cadastrar(faturamento: FaturamentoVO): Observable<Identity<number>> {
    return this.http.post<Identity<number>>
      (this.service, faturamento);
  }

  atualizar(faturamento: FaturamentoVO): Observable<any> {
    return this.http.put(this.service, faturamento);
  }

  set faturamentoContrapartida(valorContraPartida: number) {
    this.faturamentoContrapartida$.next(valorContraPartida);
  }

  obterFaturamentoContrapartida() {
    return this.faturamentoContrapartida$.asObservable();
  }

  alterarHouveFaturamentoProduto(idProduto:number, houveFaturamento: boolean): Observable<Identity<number>> {
    return this.http.put<Identity<number>>(
      `${this.service}/${idProduto}/houve-faturamento/${houveFaturamento}`, null
    )
  }
}
